/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Deep_P3Inputs */

const en_minifier_deep_p3 = /** @type {(inputs: Minifier_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The conclusion is not that minifying is pointless, it is that the payoff depends on where the bytes live. Minify when the size is uncompressed and counted directly: rows in a database column, values in localStorage or Redis, documents you are charged for by the byte, or payloads that must fit a fixed field. For an HTTP response body behind a CDN, enabling compression matters far more than minifying, and doing both buys you about a tenth on top.`)
};

const ko_minifier_deep_p3 = /** @type {(inputs: Minifier_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결론은 압축이 무의미하다는 것이 아니라, 이득이 바이트가 어디에 있는지에 달렸다는 것입니다. 크기가 압축되지 않은 상태로 직접 계산될 때 압축하세요. 데이터베이스 컬럼의 행, localStorage나 Redis의 값, 바이트 단위로 과금되는 문서, 고정 길이 필드에 들어가야 하는 페이로드가 그렇습니다. CDN 뒤의 HTTP 응답 본문이라면 압축을 켜는 것이 훨씬 중요하고, 둘 다 하면 그 위에 10분의 1 정도를 더 얻습니다.`)
};

const ja_minifier_deep_p3 = /** @type {(inputs: Minifier_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結論は圧縮が無意味ということではなく、得はバイトがどこにあるかで決まるということです。サイズが未圧縮のまま直接数えられるときに圧縮してください。データベース列の行、localStorage や Redis の値、バイト単位で課金される文書、固定長フィールドに収める必要のあるペイロードがそれです。CDN の背後の HTTP レスポンス本文なら、圧縮を有効にすることのほうがはるかに重要で、両方やればその上に 10 分の 1 ほど乗ります。`)
};

/**
* | output |
* | --- |
* | "The conclusion is not that minifying is pointless, it is that the payoff depends on where the bytes live. Minify when the size is uncompressed and counted di..." |
*
* @param {Minifier_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_deep_p3 = /** @type {((inputs?: Minifier_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_deep_p3(inputs)
	if (locale === "ko") return ko_minifier_deep_p3(inputs)
	return ja_minifier_deep_p3(inputs)
});